/**
 * DocumentSetEventEntityDefaultVarietyName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EventEntityDefaultVarietyName from 'components/EventEntityDefaultVarietyName';

// Selectors
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

interface Props {
    eventId?: number;
}

export class DocumentSetEventEntityDefaultVarietyName extends React.PureComponent<Props> {
    render() {
        const { eventId } = this.props;
        if (!eventId) return null;
        return <EventEntityDefaultVarietyName eventId={eventId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    eventId: makeSelectDocumentSetValue('eventId')
});

export default connect(mapStateToProps)(
    DocumentSetEventEntityDefaultVarietyName
);
